import { Button } from '@/components/ui/button';
import MinusButton from '@/components/ui/minus-button';
import PlusButton from '@/components/ui/plus-button';
import { Minus, X } from 'lucide-react';
import React, { useMemo } from 'react';
import '@/app/input.css';

function ShopCartItem({
  title,
  price,
  count,
  currency,
  onClickMinus,
  onClickPlus,
  onClickDelete,
}: {
  title: string;
  price: number;
  count: number;
  currency: string;
  onClickMinus: () => void;
  onClickPlus: () => void;
  onClickDelete: () => void;
}) {
  const countingPrice = useMemo(
    () => `${(price * count).toLocaleString('en-US')}${currency}`,
    [price, count, currency],
  );

  return (
    <div className="inline-flex flex-col justify-between min-h-[120px] bg-white mb-[10px] rounded-xl p-[15px] w-full">
      <div className="flex flex-row justify-between gap-[10px]">
        <p className="giftifan5 font-medium text-lg">{title}</p>
        <Button variant="ghost" className="h-5 w-5" onClick={onClickDelete}>
          <X />
        </Button>
      </div>
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center">
          <MinusButton onClick={onClickMinus} />
          <div className="min-w-8 h-6 text-center bg-[#F5F5F5] text-lg font-medium giftifan5 leading-6">
            {count}
          </div>
          <PlusButton onClick={onClickPlus} />
        </div>
        <p className="giftifan5 font-bold text-xl">{countingPrice}</p>
      </div>
    </div>
  );
}

export default ShopCartItem;
